import React from 'react';
import styled from 'styled-components';
import { colors } from '../GlobalStyles';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { MetaTags } from './MetaTags';

const PageContainer = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  overflow-x: hidden;
`;

const ContentContainer = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 8rem 2rem 4rem 2rem;
  min-height: 60vh;

  @media (max-width: 768px) {
    padding: 6rem 1rem 3rem 1rem;
  }
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: ${colors.white};
  margin-bottom: 2rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const PageContent = styled.div`
  color: ${colors.white};
  font-size: 1.1rem;
  line-height: 1.7;

  h2 {
    color: ${colors.accentOrange};
    font-size: 1.5rem;
    margin: 2rem 0 1rem 0;
    font-weight: 600;
  }

  h3 {
    color: ${colors.white};
    font-size: 1.2rem;
    margin: 1.5rem 0 0.5rem 0;
    font-weight: 600;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;

    h2 {
      font-size: 1.3rem;
    }

    h3 {
      font-size: 1.1rem;
    }
  }
`;

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  metaUrl?: string;
}

export function PageLayout({
  title,
  children,
  metaTitle,
  metaDescription,
  metaKeywords,
  metaUrl
}: PageLayoutProps) {
  return (
    <PageContainer>
      {metaTitle && (
        <MetaTags
          title={metaTitle}
          description={metaDescription}
          keywords={metaKeywords}
          url={metaUrl}
          type="article"
        />
      )}
      <Navigation />
      <ContentContainer>
        <PageTitle>{title}</PageTitle>
        <PageContent>{children}</PageContent>
      </ContentContainer>
      <Footer />
    </PageContainer>
  );
}
